import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/AuthProvider';
import { can } from './auth/roles';
import { Forbidden, RequireAuth, RequirePermission } from './components/Guards';
import { Layout } from './components/Layout';
import { Loading } from './components/ui/States';
import Login from './pages/Login';

const Overview = lazy(() => import('./pages/Overview'));
const GrowthStats = lazy(() => import('./pages/GrowthStats'));
const SharingStats = lazy(() => import('./pages/SharingStats'));
const EngagementStats = lazy(() => import('./pages/EngagementStats'));
const MandirStats = lazy(() => import('./pages/MandirStats'));
const Moderation = lazy(() => import('./pages/Moderation'));
const Users = lazy(() => import('./pages/Users'));
const PushNotifications = lazy(() => import('./pages/PushNotifications'));
const Catalog = lazy(() => import('./pages/Catalog'));
const Content = lazy(() => import('./pages/Content'));
const PointsRules = lazy(() => import('./pages/PointsRules'));
const TulsiCatalog = lazy(() => import('./pages/TulsiCatalog'));
const MandirCatalog = lazy(() => import('./pages/MandirCatalog'));
const Settings = lazy(() => import('./pages/Settings'));

function Home() {
  const { session } = useAuth();
  return can(session?.role, 'stats:view') ? <Overview /> : <Navigate to="/moderation" replace />;
}

export default function App() {
  return (
    <Suspense fallback={<div style={{ padding: 40 }}><Loading height={240} /></div>}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<RequireAuth><Layout /></RequireAuth>}>
          <Route index element={<Home />} />
          <Route path="stats/growth" element={<RequirePermission perm="stats:view"><GrowthStats /></RequirePermission>} />
          <Route path="stats/sharing" element={<RequirePermission perm="stats:view"><SharingStats /></RequirePermission>} />
          <Route path="stats/engagement" element={<RequirePermission perm="stats:view"><EngagementStats /></RequirePermission>} />
          <Route path="stats/mandir" element={<RequirePermission perm="stats:view"><MandirStats /></RequirePermission>} />
          <Route path="moderation" element={<RequirePermission perm="moderation:manage"><Moderation /></RequirePermission>} />
          <Route path="users" element={<RequirePermission perm="users:view"><Users /></RequirePermission>} />
          <Route path="catalog" element={<RequirePermission perm="catalog:manage"><Catalog /></RequirePermission>} />
          <Route path="tulsi" element={<RequirePermission perm="catalog:manage"><TulsiCatalog /></RequirePermission>} />
          <Route path="mandir" element={<RequirePermission perm="catalog:manage"><MandirCatalog /></RequirePermission>} />
          <Route path="content" element={<RequirePermission perm="content:manage"><Content /></RequirePermission>} />
          <Route path="points" element={<RequirePermission perm="points:manage"><PointsRules /></RequirePermission>} />
          <Route path="push" element={<RequirePermission perm="push:manage"><PushNotifications /></RequirePermission>} />
          <Route path="settings" element={<RequirePermission perm="settings:manage"><Settings /></RequirePermission>} />
          <Route path="*" element={<Forbidden />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
